export default "__VITE_ASSET__fcabf1c4__"